<script setup lang="ts">
import type { NuxtError } from '#app'
import NuxtErrorPage from '#app/components/nuxt-error-page.vue'

const props = defineProps<{ error: NuxtError }>()
const is404 = props.error.statusCode === 404

// The error page replaces app.vue, so the layout's site preferences are loaded here instead.
if (is404) {
  usePreferencesStore().init()
}

const { locale } = useI18n()
useHead(() => ({ htmlAttrs: { lang: localeConfig[locale.value]?.languageCode || 'en' } }))
</script>

<template>
  <NuxtLayout v-if="is404" name="default">
    <NotFoundPage />
  </NuxtLayout>
  <NuxtErrorPage v-else :error="error" />
</template>
